import React from "react";
import PropTypes from "prop-types";
import { Button } from "@learningblocks/shared-components";
import { Icons } from "@learningblocks/exp-constants";
import style from "./style.module.scss";
import { useIntl } from "react-intl";

const { IconStart } = Icons;

/**
 * SelectButton:
 *  - Select Button for LevelSelector
 */
export function SelectButton(props) {
  const intl = useIntl();
  const className = `${style.btn} ${props.className}`;
  return (
    <Button
      onClick={props.onClick}
      className={className}
      dir={intl.locale == "ar" ? "rtl" : "ltr"}
    >
      <IconStart />
      {intl.formatMessage({
        id: props.label,
        defaultMessage: props.label,
        description: "",
      })}
    </Button>
  );
}

SelectButton.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Callback for select button
   */
  onClick: PropTypes.func.isRequired,
  /**
   * Label for SelectButton
   */
  label: PropTypes.string,
};

SelectButton.defaultProps = {
  className: "",
};
